import Head from 'next/head';
import { publicImageUrl } from '../../../lib/publicImageUrl';

export default function MetaHead({ currentDomain }: { currentDomain: string }) {
    const baseUrl = `https://${currentDomain}/design-without-borders`;

    return (
        <Head>
            <title>Design Without Borders - Freelance Report 2022 | 99designs</title>
            {currentDomain === '99designs.com' ? (
                <>
                    <link
                        rel="alternate"
                        hrefLang="en"
                        href="https://99designs.com/design-without-borders"
                    />
                    <link
                        rel="alternate"
                        hrefLang="en-us"
                        href="https://99designs.com/design-without-borders"
                    />
                    <link rel="canonical" href="https://99designs.com/design-without-borders" />
                </>
            ) : (
                <meta name="robots" content="noindex" />
            )}
            <meta
                name="description"
                content="Our 2022 Global designer report is here! Uncover fresh insights and opinions from freelance designers around the world. 10,000+ designers. 144 countries. Learn more."
            />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta
                property="og:title"
                content="Get a fresh take on the world of freelance – view the designer report."
            />
            <meta
                property="og:description"
                content="10,000+ designers. 144 countries. New industry perspectives. See the world through the eyes of creatives with insights from freelancers around the world."
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={`${baseUrl}`} />
            <meta
                property="og:image"
                content={publicImageUrl('design-without-borders/og-dwb-2021-en-in.png')}
            />
        </Head>
    );
}
